"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormDynamicSelect", {
    enumerable: true,
    get: function() {
        return FormDynamicSelect;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _DropdownContainer = require("../../Dropdown/DropdownContainer");
const _Dropdown = require("../../Dropdown/Dropdown");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _Theme = require("../../../contexts/Theme");
const _useDropdownChevronBackground = require("../../../hooks/useDropdownChevronBackground");
const _FormInputGroup = /*#__PURE__*/ _interop_require_wildcard(require("../FormInputGroup"));
const _FormInput = require("../FormInput/FormInput");
const _lodash = require("lodash");
const _ri = require("react-icons/ri");
const _localisationeq1 = require("@equiem/localisation-eq1");
const _stringNotEmpty = require("../../../util/stringNotEmpty");
const _hooks = require("../../../hooks");
const _ProgressCircle = require("../../ProgressCircle/ProgressCircle");
const _FormFacadeButtonGhost = require("../FormMultiSelect/FormFacadeButtonGhost");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const Item = (param)=>{
    let { option, onChange, selectedValue, allowClear } = param;
    const { setShow } = (0, _react.useContext)(_Dropdown.DropdownContext);
    const padding = (0, _useInputPadding.useInputPadding)();
    const theme = (0, _Theme.useTheme)();
    const selected = option.value === selectedValue;
    var _option_dropLabel;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        onClick: ()=>{
            onChange === null || onChange === void 0 ? void 0 : onChange(selected ? null : option.value);
            setShow(false);
        },
        role: "option",
        className: _style.default.dynamic([
            [
                "354da76335c8592c",
                [
                    padding.top,
                    padding.bottom,
                    theme.spacers.s3,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.grayscale_5,
                    allowClear ? "none" : "inline"
                ]
            ]
        ]) + " " + "small pl-3 ".concat(selected && "selected")
    }, (_option_dropLabel = option.dropLabel) !== null && _option_dropLabel !== void 0 ? _option_dropLabel : option.label, selected && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "354da76335c8592c",
                [
                    padding.top,
                    padding.bottom,
                    theme.spacers.s3,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.grayscale_5,
                    allowClear ? "none" : "inline"
                ]
            ]
        ]) + " " + "check"
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiCheckLine, null)), allowClear && /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "354da76335c8592c",
                [
                    padding.top,
                    padding.bottom,
                    theme.spacers.s3,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.grayscale_5,
                    allowClear ? "none" : "inline"
                ]
            ]
        ]) + " " + "remove"
    }, /*#__PURE__*/ _react.default.createElement(_ri.RiCloseLine, null)))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "354da76335c8592c",
        dynamic: [
            padding.top,
            padding.bottom,
            theme.spacers.s3,
            theme.colors.lightHover,
            theme.colors.primary,
            theme.colors.grayscale_5,
            allowClear ? "none" : "inline"
        ]
    }, "div.__jsx-style-dynamic-selector{cursor:pointer;padding-top:".concat(padding.top, ";padding-bottom:").concat(padding.bottom, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}span.__jsx-style-dynamic-selector{margin-right:").concat(theme.spacers.s3, ";font-size:14px;line-height:14px}div.selected.__jsx-style-dynamic-selector{background:").concat(theme.colors.lightHover, "}.check.__jsx-style-dynamic-selector{color:").concat(theme.colors.primary, ";display:inline}.remove.__jsx-style-dynamic-selector{display:none}div.__jsx-style-dynamic-selector:hover{background:").concat(theme.colors.grayscale_5, "}div.__jsx-style-dynamic-selector:hover .check.__jsx-style-dynamic-selector{display:").concat(allowClear ? "none" : "inline", "}div.__jsx-style-dynamic-selector:hover .remove.__jsx-style-dynamic-selector{display:inline}")));
};
const ItemDisplay = (param)=>{
    let { name, options, onChange, selectedValue, allowClear } = param;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, options.map((option, index)=>/*#__PURE__*/ _react.default.createElement("div", {
            key: index,
            className: "item mx-3"
        }, /*#__PURE__*/ _react.default.createElement(Item, {
            selectedValue: selectedValue,
            option: option,
            onChange: (newValue)=>{
                onChange === null || onChange === void 0 ? void 0 : onChange({
                    target: {
                        name,
                        value: newValue !== null && newValue !== void 0 ? newValue : ""
                    }
                });
            },
            allowClear: allowClear
        }))));
};
const GroupDisplay = (param)=>{
    let { name, filteredOptions, onChange, selectedValue, allowClear } = param;
    const theme = (0, _Theme.useTheme)();
    const allGroups = (0, _react.useMemo)(()=>filteredOptions.reduce((prev, curr)=>{
            if (curr.group != null) {
                var _prev_curr_group_name;
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                prev[curr.group.name] = ((_prev_curr_group_name = prev[curr.group.name]) !== null && _prev_curr_group_name !== void 0 ? _prev_curr_group_name : []).concat([
                    curr
                ]);
            }
            return prev;
        }, {}), [
        filteredOptions
    ]);
    const allKeys = (0, _react.useMemo)(()=>Object.keys(allGroups).map((key)=>{
            var _filteredOptions_find_group, _filteredOptions_find;
            var _filteredOptions_find_group_weight;
            return {
                name: key,
                weight: (_filteredOptions_find_group_weight = (_filteredOptions_find = filteredOptions.find((option)=>{
                    var _option_group;
                    return ((_option_group = option.group) === null || _option_group === void 0 ? void 0 : _option_group.name) === key;
                })) === null || _filteredOptions_find === void 0 ? void 0 : (_filteredOptions_find_group = _filteredOptions_find.group) === null || _filteredOptions_find_group === void 0 ? void 0 : _filteredOptions_find_group.weight) !== null && _filteredOptions_find_group_weight !== void 0 ? _filteredOptions_find_group_weight : 0
            };
        }).sort((a, b)=>a.weight - b.weight), [
        allGroups,
        filteredOptions
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, allKeys.map((group, groupIndex)=>/*#__PURE__*/ _react.default.createElement("div", {
            key: groupIndex,
            className: _style.default.dynamic([
                [
                    "7676708bf2f48e87",
                    [
                        theme.colors.border,
                        theme.spacers.s4,
                        theme.spacers.s4,
                        theme.spacers.s4,
                        theme.spacers.s3,
                        theme.spacers.s2
                    ]
                ]
            ]) + " " + "group"
        }, /*#__PURE__*/ _react.default.createElement("label", {
            className: _style.default.dynamic([
                [
                    "7676708bf2f48e87",
                    [
                        theme.colors.border,
                        theme.spacers.s4,
                        theme.spacers.s4,
                        theme.spacers.s4,
                        theme.spacers.s3,
                        theme.spacers.s2
                    ]
                ]
            ])
        }, group.name), /*#__PURE__*/ _react.default.createElement(ItemDisplay, {
            selectedValue: selectedValue,
            name: name,
            options: allGroups[group.name],
            onChange: onChange,
            allowClear: allowClear
        }))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "7676708bf2f48e87",
        dynamic: [
            theme.colors.border,
            theme.spacers.s4,
            theme.spacers.s4,
            theme.spacers.s4,
            theme.spacers.s3,
            theme.spacers.s2
        ]
    }, ".group.__jsx-style-dynamic-selector{border-bottom:1px solid ".concat(theme.colors.border, ";padding-bottom:").concat(theme.spacers.s4, ";margin-bottom:").concat(theme.spacers.s4, "}.group.__jsx-style-dynamic-selector:last-child{border:0;margin:0;padding:0}.group.__jsx-style-dynamic-selector label.__jsx-style-dynamic-selector{display:block;margin:0 ").concat(theme.spacers.s4, " ").concat(theme.spacers.s3, ";padding:0 ").concat(theme.spacers.s2, ";font-size:11px;text-transform:uppercase;font-weight:500}")));
};
const FormDynamicSelect = (param)=>{
    let { name, className = "", value, options, onChange, searchCb, showChrome = true, search = false, title, size = "md", searchPlaceholder, mobileView, noneLabel, disabled = false, showSelectedOnList = false, facade, minWidth = 0, allowClear = false, readOnly } = param;
    const { t } = (0, _localisationeq1.useTranslation)();
    const { colors, borderRadius, spacers } = (0, _Theme.useTheme)();
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        showChrome: readOnly != null ? !readOnly : showChrome
    });
    const dropdownBg = (0, _useDropdownChevronBackground.useDropdownChevronBackground)({
        color: colors.grayscale[100]
    });
    const [localValue, setLocalValue] = (0, _react.useState)(value);
    const [selected, setSelected] = (0, _react.useState)(options === null || options === void 0 ? void 0 : options.find((option)=>option.value === localValue));
    const [searching, setSearching] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setLocalValue(value);
        setSelected(options === null || options === void 0 ? void 0 : options.find((option)=>option.value === value));
    }, [
        options,
        value
    ]);
    const DEFAULT_WIDTH = 300;
    const [width, setWidth] = (0, _react.useState)(DEFAULT_WIDTH);
    const FILTER_DEBOUNCE_MS = 500;
    const [filterText, setFilterText] = (0, _react.useState)(null);
    const debouncedFilter = (0, _hooks.useDebounced)(filterText, FILTER_DEBOUNCE_MS);
    // Handle the search callback when exist.
    (0, _react.useEffect)(()=>{
        if (debouncedFilter != null && searchCb != null) {
            searchCb(debouncedFilter).finally(()=>{
                setSearching(false);
            });
        }
    }, [
        debouncedFilter,
        searchCb
    ]);
    const ref = (0, _react.useRef)(null);
    const adjustWidth = (0, _react.useCallback)(()=>{
        if (ref.current != null) {
            const newWidth = Math.max(ref.current.getBoundingClientRect().width, minWidth);
            setWidth(newWidth);
        }
    }, [
        minWidth
    ]);
    (0, _react.useEffect)(()=>{
        window.addEventListener("resize", adjustWidth);
        adjustWidth();
        return ()=>window.removeEventListener("resize", adjustWidth);
    }, [
        adjustWidth
    ]);
    const emptyLabel = noneLabel != null ? /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, noneLabel) : null;
    const filteredOptions = (0, _react.useMemo)(()=>{
        const searchmode = searchCb == null && (0, _stringNotEmpty.stringNotEmpty)(filterText);
        const searchKeyword = filterText === null || filterText === void 0 ? void 0 : filterText.toLowerCase();
        return (options !== null && options !== void 0 ? options : []).filter((option)=>{
            const optionKeywords = option.searchKeywords != null && option.searchKeywords.length > 0 ? option.searchKeywords : [
                String(option.label)
            ];
            const getFilteredCondition = searchmode && (0, _stringNotEmpty.stringNotEmpty)(searchKeyword) ? optionKeywords.some((ok)=>(0, _lodash.includes)(ok.toLowerCase(), searchKeyword)) : true;
            const includeSelected = showSelectedOnList ? true : option.value !== localValue;
            return includeSelected && option.dropLabel !== false && getFilteredCondition;
        });
    }, [
        options,
        filterText,
        searchCb,
        showSelectedOnList,
        localValue
    ]);
    const hasGroup = (0, _react.useMemo)(()=>(options !== null && options !== void 0 ? options : []).some((option)=>{
            var _option_group;
            return (0, _stringNotEmpty.stringNotEmpty)((_option_group = option.group) === null || _option_group === void 0 ? void 0 : _option_group.name);
        }), [
        options
    ]);
    var _selected_facadeLabel, _ref, _ref1;
    const label = (_ref1 = (_ref = (_selected_facadeLabel = selected === null || selected === void 0 ? void 0 : selected.facadeLabel) !== null && _selected_facadeLabel !== void 0 ? _selected_facadeLabel : selected === null || selected === void 0 ? void 0 : selected.label) !== null && _ref !== void 0 ? _ref : emptyLabel) !== null && _ref1 !== void 0 ? _ref1 : t("common.none");
    return /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        className: _style.default.dynamic([
            [
                "366faced57aef924",
                [
                    colors.grayscale_5,
                    borderRadius,
                    size === "sm" ? spacers.s3 : spacers.s4,
                    disabled ? "0.5" : "1",
                    disabled ? "not-allowed" : "pointer",
                    disabled ? colors.grayscale[5] : colors.white,
                    showChrome === true && readOnly !== true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none",
                    readOnly !== true && (showChrome === true || showChrome === "onInteraction") ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none"
                ]
            ]
        ]) + " " + (className || "")
    }, /*#__PURE__*/ _react.default.createElement(_DropdownContainer.DropdownContainer, {
        placement: "bottom-start",
        width: width,
        mobileView: mobileView,
        title: title,
        disabled: disabled || readOnly,
        trigger: facade === "ghost" ? /*#__PURE__*/ _react.default.createElement(_FormFacadeButtonGhost.FormFacadeButtonGhost, {
            placeholder: name,
            className: className,
            size: size === "sm" ? "small" : "large"
        }) : /*#__PURE__*/ _react.default.createElement("div", {
            tabIndex: 0,
            className: _style.default.dynamic([
                [
                    "366faced57aef924",
                    [
                        colors.grayscale_5,
                        borderRadius,
                        size === "sm" ? spacers.s3 : spacers.s4,
                        disabled ? "0.5" : "1",
                        disabled ? "not-allowed" : "pointer",
                        disabled ? colors.grayscale[5] : colors.white,
                        showChrome === true && readOnly !== true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none",
                        readOnly !== true && (showChrome === true || showChrome === "onInteraction") ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none"
                    ]
                ]
            ]) + " " + "triggerInput small mr-5 ".concat(borderCss.className)
        }, label)
    }, search && /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Group, {
        className: "mx-3 mt-2 mb-4"
    }, /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Prefix, null, searching ? /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
        size: 15,
        style: {
            color: colors.muted1
        }
    }) : /*#__PURE__*/ _react.default.createElement(_ri.RiSearchLine, {
        color: colors.muted1,
        size: 15
    })), /*#__PURE__*/ _react.default.createElement(_FormInput.FormInput, {
        placeholder: searchPlaceholder !== null && searchPlaceholder !== void 0 ? searchPlaceholder : t("common.searchAttributes"),
        onChange: (e)=>{
            searchCb != null && setSearching(true);
            setFilterText(e.target.value);
        },
        className: "p-2",
        value: filterText !== null && filterText !== void 0 ? filterText : "",
        autoFocus: true
    }), /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Suffix, null, /*#__PURE__*/ _react.default.createElement(_ri.RiCloseCircleLine, {
        style: {
            display: filterText == null || filterText.length === 0 ? "none" : "block",
            cursor: "pointer"
        },
        onClick: ()=>setFilterText(""),
        color: colors.muted1,
        size: 15
    }))), !searching && /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, hasGroup ? /*#__PURE__*/ _react.default.createElement(GroupDisplay, {
        selectedValue: localValue,
        filteredOptions: filteredOptions,
        name: name,
        onChange: onChange,
        allowClear: allowClear
    }) : /*#__PURE__*/ _react.default.createElement(ItemDisplay, {
        selectedValue: localValue,
        options: filteredOptions,
        name: name,
        onChange: onChange,
        allowClear: allowClear
    }))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "366faced57aef924",
        dynamic: [
            colors.grayscale_5,
            borderRadius,
            size === "sm" ? spacers.s3 : spacers.s4,
            disabled ? "0.5" : "1",
            disabled ? "not-allowed" : "pointer",
            disabled ? colors.grayscale[5] : colors.white,
            showChrome === true && readOnly !== true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none",
            readOnly !== true && (showChrome === true || showChrome === "onInteraction") ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none"
        ]
    }, "label.__jsx-style-dynamic-selector{cursor:pointer}.item.__jsx-style-dynamic-selector:hover{background-color:".concat(colors.grayscale_5, ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, "}.triggerInput.__jsx-style-dynamic-selector{width:100%;height:100%;padding:").concat(size === "sm" ? spacers.s3 : spacers.s4, ";opacity:").concat(disabled ? "0.5" : "1", ";cursor:").concat(disabled ? "not-allowed" : "pointer", ";font-size:.875rem;background-color:").concat(disabled ? colors.grayscale[5] : colors.white, "!important;background:").concat(showChrome === true && readOnly !== true ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none", "}.triggerInput.__jsx-style-dynamic-selector:hover,.triggerInput.__jsx-style-dynamic-selector:focus,.focus-in.__jsx-style-dynamic-selector{background:").concat(readOnly !== true && (showChrome === true || showChrome === "onInteraction") ? "".concat(dropdownBg, " right 11px center/16px 16px no-repeat") : "none", "}")), borderCss.styles);
};

//# sourceMappingURL=FormDynamicSelect.js.map